import React, { useState } from "react";
import {
  Card,
  CardTitle,
  CardText,
  Input,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./CustomCard.scss";
import { useDispatch } from "react-redux";
import { DELETE_NEGOTIATION_ACTION } from "../../redux/Action/actionTypes";

interface CustomCardProps {
  id: string;
  title: string;
  description: string;
  flag: string;
  actionType: any;
  isTrending: any;
  isMostSelected: any;
  avgRating: any;
  inputText: string;
  isCardSelected?: boolean;
  onInputChange: (newValue: string) => void;
}

const CustomCard = ({
  id,
  title,
  description,
  flag,
  actionType,
  isTrending,
  isMostSelected,
  avgRating,
  inputText,
  onInputChange,
  isCardSelected,
}: CustomCardProps) => {
  const [deleteModel, setDeleteModel] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const dispatch = useDispatch();
  const handleDelete = (id: any) => {
    setItemToDelete(id.id);
    setDeleteModel(true);
  };
  const confirmDelete = () => {
    dispatch({
      type: DELETE_NEGOTIATION_ACTION,
      payload: { id: itemToDelete, status: false },
    });
    setDeleteModel(false);
    setItemToDelete(null);
  };

  let badgeUI = (
    <div className="card-badges">
      <div className="BadgeAndBin">
        {actionType === "UserCreated" && (
          <>
            <Badge className="badge-own-creation">Own creation</Badge>
            <button
              className="delete-card"
              onClick={(e) => {
                e.stopPropagation();
                handleDelete({ id });
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                className="bi bi-trash3"
                viewBox="0 0 18 18"
              >
                <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
              </svg>
            </button>
          </>
        )}
        {flag === "Early rounds" && (
          <div className="BadgeAndBin">
            <Badge className="badge-early-round" color="danger">Early rounds</Badge>
          </div>
        )}

        {flag === "Late rounds" && (
          <div className="BadgeAndBin">
            <Badge className="badge-late-round" color="success">Late rounds</Badge>
          </div>
        )}
      </div>
      {isMostSelected && (
        <div className="BadgeAndBin">
          {actionType === "UserCreated" &&
            <Badge className="badge-mostSelected-customcard" color="warning">Most selected</Badge>
          }
          {actionType=== "Default" &&
          <Badge className="badge-mostSelected" color="warning">Most selected</Badge>
          }
        </div>
      )}
      {isTrending && (
        <div className="BadgeAndBin">
          <Badge className="badge-Trending" color="info">Trending</Badge>
        </div>
      )}
    </div>
  );


  return (
    <Card className={isCardSelected ? "selected-card" : "default-card"}>
      <div className="custom-card"></div>
      {badgeUI}
      <CardTitle className="card-title">{title} ({avgRating}★)</CardTitle>
      <CardText className="card-description">{description}</CardText>
      <div>
        <strong className="implementation-plan">My implementation plan:</strong>
        <Input
          type="textarea"
          rows={2}
          placeholder="..."
          value={inputText}
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => {
            const trimmed = e.target.value.slice(0, 1000);
            onInputChange(trimmed);
          }}
          style={{ fontSize: "14px", marginTop: "5px" }}
        />
      </div>
      {inputText?.length === 1000 && (
        <div className="input-text">Maximum 1000 characters allowed</div>
      )}
      <Modal isOpen={deleteModel} toggle={() => setDeleteModel(false)}>
        <ModalHeader toggle={() => setDeleteModel(false)}>
          Confirm Deletion
        </ModalHeader>
        <ModalBody>Are you sure you want to delete this action?</ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            size="sm"
            onClick={() => setDeleteModel(false)}
          >
            Don't delete
          </Button>
          <Button color="danger" size="sm" onClick={confirmDelete}>
            Yes
          </Button>
        </ModalFooter>
      </Modal>
    </Card>
  );
};

export default CustomCard;
